export default {
      id: "ic_chevron_right_current-usage",
      viewBox: "0 0 21 20",
      url: "/" + "images/icons.3.109.2.svg#ic_chevron_right_current-usage",
      toString: function () {
        return this.url;
      }
    }